jQuery(function ($) {
    const $page = $('.wheels-catalog-page');
    if (!$page.length) return;

    const $form = $('#wheels-catalog-form');
    if (!$form.length) return;

    const $wrapper = $('#wheels-wrapper');
    const $resultsContainer = $('.wheels-catalog-results');
    const $noResults = $('.wheels-catalog-no-results');
    const $loadingIndicator = $('.wheels-catalog-loading');
    const $loadMore = $('#wheels-load-more-indicator');

    const LOCAL_STORAGE_KEY = 'wheels_catalog_filters';
    const DEFAULT_FILTERS = { sort: 'latest' };

    const SESSION_KEYS = {
        html: 'wheelsCatalogHtml',
        page: 'wheelsCatalogPage',
        hasMore: 'wheelsCatalogHasMore',
        filters: 'wheelsCatalogFilters',
        scroll: 'wheelsCatalogScroll'
    };

    let isInitializing = true;
    let submitTimer = null;
    let wheelsRequest = null;
    let currentPage = parseInt($page.data('current-page'), 10) || 1;
    let hasMore = String($page.data('has-more')) === '1' || $page.data('has-more') === true;
    let isLoading = false;
    let scrollTimer = null;
    let isRestoringWheelsCatalogState = false;
    let currentFilters = {};

    try {
        if (window.history && typeof window.history.scrollRestoration !== 'undefined') {
            window.history.scrollRestoration = 'manual';
        }
    } catch (e) {}

    function revealWheelCards($root) {
        const $scope = ($root && $root.length) ? $root : $wrapper;
        if (!$scope.length) return;
        $scope.find('.single-car.before-animation-visibility-backface')
            .removeClass('before-animation-visibility-backface');
    }

    function safeParseJson(raw) {
        if (!raw || typeof raw !== 'string') return null;
        try {
            return JSON.parse(raw);
        } catch (e) {
            return null;
        }
    }

    function getFiltersFromForm() {
        const filters = {};
        $form.serializeArray().forEach(function (field) {
            if (field.name === 'page') return;
            if (field.value !== '' && field.value !== 'all') {
                filters[field.name] = field.value;
            }
        });
        if (!filters.sort) {
            filters.sort = DEFAULT_FILTERS.sort;
        }
        return filters;
    }

    function getFiltersFromUrl() {
        const filters = {};
        try {
            const params = new URLSearchParams(window.location.search || '');
            params.forEach(function (value, key) {
                if (key === 'page' || value === '' || value === 'all') return;
                filters[key] = value;
            });
        } catch (e) {}
        return filters;
    }

    function getWheelsFiltersKey(filters) {
        const f = filters && typeof filters === 'object' ? filters : {};
        const keys = Object.keys(f).sort();
        const normalized = {};
        keys.forEach(function (key) {
            normalized[key] = f[key];
        });
        return JSON.stringify(normalized);
    }

    function hasMeaningfulWheelsFilters(filters) {
        if (!filters || typeof filters !== 'object') return false;
        return Object.keys(filters).some(function (key) {
            if (key === 'sort') {
                return String(filters[key] || DEFAULT_FILTERS.sort) !== DEFAULT_FILTERS.sort;
            }
            const value = filters[key];
            return value !== '' && value !== null && value !== undefined && value !== 'all';
        });
    }

    function saveWheelsFiltersToStorage(filters) {
        try {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters || {}));
        } catch (e) {}
    }

    function loadWheelsFiltersFromStorage() {
        try {
            const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
            return raw ? safeParseJson(raw) : null;
        } catch (e) {
            return null;
        }
    }

    function clearWheelsFiltersStorage() {
        try {
            localStorage.removeItem(LOCAL_STORAGE_KEY);
        } catch (e) {}
    }

    function cleanWheelsCatalogUrl() {
        try {
            const hash = window.location.hash || '';
            const next = '/catalog/wheels' + hash;
            if (window.location.pathname + window.location.search + hash !== next) {
                window.history.replaceState({}, '', next);
            }
        } catch (e) {}
    }

    function migrateLegacyUrlFiltersToStorage() {
        const fromUrl = getFiltersFromUrl();
        if (!Object.keys(fromUrl).length) {
            return false;
        }
        saveWheelsFiltersToStorage(fromUrl);
        cleanWheelsCatalogUrl();
        return true;
    }

    function shouldRestoreFromSession() {
        try {
            const entries = typeof performance !== 'undefined' ? performance.getEntriesByType('navigation') : [];
            const nav = entries && entries.length ? entries[0] : null;
            if (nav && nav.type === 'back_forward') {
                return true;
            }
        } catch (e) {}
        try {
            if (typeof performance !== 'undefined' && performance.navigation && performance.navigation.type === 2) {
                return true;
            }
        } catch (e2) {}
        return false;
    }

    function restoreWheelsScroll(targetY) {
        const y = Number(targetY);
        if (!Number.isFinite(y) || y <= 0) return;

        const attemptScroll = function (triesLeft) {
            try {
                window.scrollTo(0, y);
            } catch (e) {}
            if (triesLeft <= 0) return;
            const currentY = window.scrollY || window.pageYOffset || 0;
            if (Math.abs(currentY - y) > 2) {
                requestAnimationFrame(function () {
                    attemptScroll(triesLeft - 1);
                });
            }
        };

        requestAnimationFrame(function () {
            attemptScroll(10);
        });
    }

    function setWheelsFiltersInForm(filters) {
        if (!filters || typeof filters !== 'object') return;
        Object.keys(filters).forEach(function (name) {
            const $sel = $form.find('[name="' + name + '"]');
            if (!$sel.length) return;
            const val = filters[name];
            const el = $sel[0];
            if (el && el.selectize) {
                el.selectize.setValue(val, true);
            } else {
                $sel.val(val);
            }
        });
    }

    function resetWheelsFiltersInForm() {
        $form.find('select').each(function () {
            const el = this;
            if (el.selectize) {
                el.selectize.setValue('all', true);
            } else {
                $(el).val('all');
            }
        });
        $form.find('input[name="price_from"], input[name="price_to"]').val('');
        const sortEl = $form.find('[name="sort"]')[0];
        if (sortEl && sortEl.selectize) {
            sortEl.selectize.setValue(DEFAULT_FILTERS.sort, true);
        } else {
            $form.find('[name="sort"]').val(DEFAULT_FILTERS.sort);
        }
    }

    function persistWheelsCatalogState() {
        if (!$wrapper.length) return;
        try {
            sessionStorage.setItem(SESSION_KEYS.html, $wrapper.html() || '');
            sessionStorage.setItem(SESSION_KEYS.page, String(currentPage || 1));
            sessionStorage.setItem(SESSION_KEYS.hasMore, String(!!hasMore));
            sessionStorage.setItem(SESSION_KEYS.filters, JSON.stringify(getFiltersFromForm()));
            sessionStorage.setItem(SESSION_KEYS.scroll, String(window.scrollY || window.pageYOffset || 0));
        } catch (e) {}
    }

    function restoreWheelsCatalogStateFromSession(expectedFiltersKey) {
        const cachedHtml = sessionStorage.getItem(SESSION_KEYS.html);
        const cachedFiltersRaw = sessionStorage.getItem(SESSION_KEYS.filters);
        if (!cachedHtml || !cachedFiltersRaw) return false;

        const cachedFilters = safeParseJson(cachedFiltersRaw) || {};
        const cachedKey = getWheelsFiltersKey(cachedFilters);
        if (expectedFiltersKey && cachedKey && expectedFiltersKey !== cachedKey) {
            return false;
        }

        isRestoringWheelsCatalogState = true;

        try {
            $wrapper.html(cachedHtml);
            revealWheelCards($wrapper);
            $resultsContainer.removeClass('d-none').show();
            $noResults.addClass('d-none').hide();
        } catch (e) {}

        const pageRaw = sessionStorage.getItem(SESSION_KEYS.page);
        const hasMoreRaw = sessionStorage.getItem(SESSION_KEYS.hasMore);
        const restoredPage = parseInt(pageRaw || '1', 10);
        currentPage = Number.isFinite(restoredPage) && restoredPage >= 1 ? restoredPage : 1;
        hasMore = hasMoreRaw === 'true';
        currentFilters = cachedFilters;
        $page.data('current-page', currentPage);
        $page.data('has-more', hasMore ? '1' : '0');

        setWheelsFiltersInForm(cachedFilters);
        saveWheelsFiltersToStorage(cachedFilters);
        cleanWheelsCatalogUrl();
        restoreWheelsScroll(parseInt(sessionStorage.getItem(SESSION_KEYS.scroll) || '0', 10));

        setTimeout(function () {
            isRestoringWheelsCatalogState = false;
        }, 1000);

        return true;
    }

    function openFiltersSection() {
        const $btn = $page.find('.catalog-filters-dropdown .catalog-filters-dropdown-link').first();
        const $filtersSection = $page.find('.filters-section').first();
        if (!$btn.length || !$filtersSection.length) return;
        if ($filtersSection.is(':visible')) return;
        $filtersSection.stop(true, true).slideDown(0);
        $filtersSection.addClass('filters-open');
        $btn.addClass('opened-filters active');
        $btn.find('.close-hidden').addClass('d-block');
    }

    $(document).on('click', '.wheels-catalog-page .catalog-filters-dropdown .catalog-filters-dropdown-link', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(this);
        var $catalogPage = $btn.closest('.catalog-page');
        var $filtersSection = $catalogPage.find('.filters-section').first();
        var $closeHidden = $btn.find('.close-hidden');

        $filtersSection.stop(true, true).slideToggle(300, function () {
            const isVisible = $filtersSection.is(':visible');
            $filtersSection.toggleClass('filters-open', isVisible);
            $btn.toggleClass('opened-filters', isVisible);
            $btn.toggleClass('active', isVisible);
            $closeHidden.toggleClass('d-block', isVisible);
        });
    });

    function showLoading(show) {
        if (!$loadingIndicator.length) return;
        $loadingIndicator.toggleClass('d-none', !show);
    }

    function showResults(hasResults) {
        if (hasResults) {
            $resultsContainer.removeClass('d-none').show();
            $noResults.addClass('d-none').hide();
        } else {
            $resultsContainer.addClass('d-none').hide();
            $noResults.removeClass('d-none').show();
        }
    }

    function handleWheelsResponse(response, append) {
        isLoading = false;
        showLoading(false);
        if ($loadMore.length) $loadMore.addClass('d-none');

        if (response && response.success && response.html) {
            if (append) {
                $wrapper.append(response.html);
            } else {
                $wrapper.html(response.html);
            }
            revealWheelCards($wrapper);
            showResults(true);
            hasMore = !!response.hasMore;
            if (typeof response.currentPage !== 'undefined') {
                currentPage = parseInt(response.currentPage, 10) || currentPage;
            }
            $page.data('current-page', currentPage);
            $page.data('has-more', hasMore ? '1' : '0');
            persistWheelsCatalogState();
            return;
        }

        if (!append) {
            $wrapper.html('');
            showResults(false);
        }
        hasMore = false;
        $page.data('has-more', '0');
    }

    function postWheels(payload, append) {
        if (wheelsRequest && wheelsRequest.readyState !== 4) {
            try { wheelsRequest.abort(); } catch (e) {}
        }

        const finish = function () {
            if (isLoading && !append) {
                isLoading = false;
                showLoading(false);
            }
        };

        const onSuccess = function (response) {
            handleWheelsResponse(response, append);
        };

        const onError = function () {
            isLoading = false;
            showLoading(false);
            if ($loadMore.length) $loadMore.addClass('d-none');
            if (!append) {
                showResults(false);
            }
            hasMore = false;
            $page.data('has-more', '0');
        };

        if (typeof csrfSafeAjaxPost === 'function') {
            wheelsRequest = csrfSafeAjaxPost(
                '/ajax/wheels/load-wheels',
                payload,
                onSuccess,
                onError,
                finish
            );
            return;
        }

        wheelsRequest = $.ajax({
            url: '/ajax/wheels/load-wheels',
            method: 'POST',
            dataType: 'json',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': window.CSRFHelper && typeof window.CSRFHelper.getCSRFCookie === 'function'
                    ? window.CSRFHelper.getCSRFCookie()
                    : ($('meta[name="csrf-token"]').attr('content') || '')
            },
            data: (function () {
                const data = Object.assign({}, payload);
                if (window.CSRFHelper && typeof window.CSRFHelper.injectCSRF === 'function') {
                    return window.CSRFHelper.injectCSRF(data);
                }
                const csrfName = $('meta[name="csrf-token-name"]').attr('content') || 'carbuy_csrf';
                data[csrfName] = $('meta[name="csrf-token"]').attr('content') || '';
                return data;
            })()
        }).done(onSuccess).fail(onError).always(finish);
    }

    function applyWheelsFilters(delayMs) {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
            if (isLoading || isRestoringWheelsCatalogState) return;

            const nextFilters = getFiltersFromForm();
            const nextKey = getWheelsFiltersKey(nextFilters);
            const currentKey = getWheelsFiltersKey(currentFilters);
            const hasRendered = $wrapper.find('.single-car').length > 0 || $noResults.is(':visible');

            if (nextKey === currentKey && hasRendered) {
                cleanWheelsCatalogUrl();
                return;
            }

            isLoading = true;
            currentPage = 1;
            hasMore = true;
            currentFilters = nextFilters;

            saveWheelsFiltersToStorage(nextFilters);
            cleanWheelsCatalogUrl();
            showLoading(true);

            postWheels({ page: 1, filters: nextFilters }, false);

            if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackCatalogSearch === 'function') {
                const parts = Object.keys(nextFilters).map(function (key) {
                    return key + ':' + nextFilters[key];
                });
                if (parts.length) {
                    window.CarBuyAnalytics.trackCatalogSearch({
                        search_string: parts.join(' '),
                        content_category: 'wheels',
                        source: 'wheels_catalog_ajax'
                    });
                }
            }
        }, typeof delayMs === 'number' ? delayMs : 120);
    }

    $form.on('submit', function (e) {
        e.preventDefault();
        applyWheelsFilters(0);
    });

    if (typeof $.fn.selectize !== 'undefined') {
        $page.find('.wheels-filter-selectize').each(function () {
            const $select = $(this);
            if ($select.hasClass('selectized')) return;

            $select.selectize({
                plugins: ['clear_on_focus'],
                onChange: function () {
                    if (isInitializing) return;
                    applyWheelsFilters(80);
                }
            });
        });
    }

    $form.on('input', 'input[name="price_from"], input[name="price_to"]', function () {
        if (isInitializing) return;
        applyWheelsFilters(420);
    });

    $form.on('change', 'select', function () {
        if (isInitializing) return;
        applyWheelsFilters(80);
    });

    $(document).on('click', '.wheels-catalog-clear-filters', function (e) {
        e.preventDefault();
        clearWheelsFiltersStorage();
        resetWheelsFiltersInForm();
        applyWheelsFilters(0);
    });

    function loadMoreWheels() {
        if (isRestoringWheelsCatalogState || isLoading || !hasMore || !$wrapper.length) return;
        if ($wrapper.find('.single-car').length === 0) return;

        isLoading = true;
        if ($loadMore.length) $loadMore.removeClass('d-none');

        const nextPage = currentPage + 1;
        postWheels({ page: nextPage, filters: getFiltersFromForm() }, true);
    }

    $(window).on('scroll', function () {
        if (!isRestoringWheelsCatalogState) {
            try {
                sessionStorage.setItem(SESSION_KEYS.scroll, String(window.scrollY || window.pageYOffset || 0));
            } catch (e) {}
        }

        if (isRestoringWheelsCatalogState || !hasMore || isLoading) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
            const el = $wrapper[0];
            if (!el) return;
            const rect = el.getBoundingClientRect();
            if (rect.bottom - window.innerHeight < 300) {
                loadMoreWheels();
            }
        }, 200);
    });

    $(document).on('click', '#wheels-wrapper a.single-car-link', function () {
        persistWheelsCatalogState();
    });

    migrateLegacyUrlFiltersToStorage();

    if (window.location.hash === '#open-filters') {
        openFiltersSection();
    } else {
        const stored = loadWheelsFiltersFromStorage();
        if (stored && hasMeaningfulWheelsFilters(stored)) {
            openFiltersSection();
        }
    }

    try {
        if (shouldRestoreFromSession()) {
            const expectedKey = getWheelsFiltersKey(loadWheelsFiltersFromStorage() || getFiltersFromForm());
            if (!restoreWheelsCatalogStateFromSession(expectedKey)) {
                const stored = loadWheelsFiltersFromStorage();
                if (stored && Object.keys(stored).length) {
                    setWheelsFiltersInForm(stored);
                    currentFilters = stored;
                }
            }
        } else {
            const stored = loadWheelsFiltersFromStorage();
            if (stored && Object.keys(stored).length) {
                setWheelsFiltersInForm(stored);
                currentFilters = stored;
            } else if ($wrapper.length && $wrapper.find('.single-car').length) {
                currentFilters = getFiltersFromForm();
                persistWheelsCatalogState();
            }
        }
    } catch (e) {}

    setTimeout(function () {
        isInitializing = false;

        cleanWheelsCatalogUrl();

        const stored = loadWheelsFiltersFromStorage();
        const defaultKey = getWheelsFiltersKey({ sort: DEFAULT_FILTERS.sort });
        const storedKey = getWheelsFiltersKey(stored || {});

        if (shouldRestoreFromSession()) {
            revealWheelCards();
            return;
        }

        if (stored && hasMeaningfulWheelsFilters(stored) && storedKey !== defaultKey) {
            applyWheelsFilters(0);
            return;
        }

        currentFilters = getFiltersFromForm();
        revealWheelCards();
    }, 0);
});
